<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="stores-map-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <base-map
                        :markers="stores"
                        :center="center"
                        ref="baseMap"
                    >
                        <store-map-popover
                            v-for="store in stores"
                            :key="store.id"
                            :slot="`marker_info_window_${ store.id }`"
                            :name="store.name"
                            :address="store.address"
                        />
                    </base-map>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import BaseMap from '../../molecules/BaseMap/BaseMap';
    import StoreMapPopover from '../../molecules/StoreMapPopover/StoreMapPopover';
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'stores-map-section',

        components: { StoreMapPopover, BaseMap },

        data() {
            return {
                stores: [],
            };
        },

        computed: {
            ...mapState('user', [
                'lat',
                'lng',
            ]),

            /**
             * Return the map center location.
             *
             * @returns {null|{lng, lat}}
             */
            center() {
                return {
                    lat: this.lat,
                    lng: this.lng,
                };
            },
        },

        /**
         * Fetch the stores from the api.
         */
        async fetch() {
            const { stores } = await this.getStores();

            this.stores = (stores || []).map((store) => ({
                id: store.documentId,
                name: store.retailer?.name,
                lat: store.location_lat,
                lng: store.location_lng,
                address: store.address,
            }));
        },

        methods: {
            ...mapActions('stores', [
                'getStores',
            ]),
        },
    };
</script>
